/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_In_Desktop_Continue_ButtonInputs */



/**
* | output |
* | --- |
* | "Continue in Browser" |
*
* @param {Open_In_Desktop_Continue_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_in_desktop_continue_button = /** @type {((inputs?: Open_In_Desktop_Continue_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_In_Desktop_Continue_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer dans le navigateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Browser fortfahren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continua nel browser")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжить в браузере")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continuar en el navegador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在浏览器中继续")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ブラウザで続行")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ब्राउज़र में जारी रखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Continuar no navegador")
	return /** @type {LocalizedString} */ ("Continue in Browser")
});